import { convertLocaltoUTCFormat } from "../services/DateFormatUtility";

export const EUETS_VOYAGES_COLUMNS = [
	{
		accessorKey: "portOfDeparture",
		header: "Port of Departure",
		size: 200,
	},
	{
		accessorKey: "portOfArrival",
		header: "Port of Arrival",
	},
	{
		accessorKey: "dateTimeOfDeparture",
		header: "Date and Time of Departure(UTC)",
		accessorFn: (row) => {
			if (row.dateTimeOfDeparture) {
				return convertLocaltoUTCFormat(row.dateTimeOfDeparture);
			}
		},
	},
	{
		accessorKey: "dateTimeOfArrival",
		header: "Date and Time of Arrival(UTC)",
		accessorFn: (row) => {
			if (row.dateTimeOfArrival) {
				return convertLocaltoUTCFormat(row.dateTimeOfArrival);
			}
		},
	},
	{
		accessorKey: "portalVerificationStatus",
		header: "Portal Initial Verification Status",
	},
	{
		accessorKey: "co2mrv",
		header: "CO2 MRV",
		size: 120,
	},
	{
		accessorKey: "ch4mrv",
		header: "CH4 MRV",
		size: 120,
	},
	{
		accessorKey: "n2omrv",
		header: "N2O MRV",
		size: 120,
	},
	{
		accessorKey: "reductionFactor",
		header: "Reduction Factor",
	},
	{
		accessorKey: "carbonCaptureAndStorage",
		header: "Carbon Capture & Storage",
	},
	{
		accessorKey: "ghgmrv",
		header: "GHG MRV",
	},
];

export const EUETS_PORTSTAYS_COLUMNS = [
	{
		accessorKey: "portName",
		header: "Port",
		size: 100,
	},
	{
		accessorKey: "dateTimeOfArrival",
		header: "Date and Time of Arrival(UTC)",
		accessorFn: (row) => {
			if (row.dateTimeOfArrival) {
				return convertLocaltoUTCFormat(row.dateTimeOfArrival);
			}
		},
	},
	{
		accessorKey: "dateTimeOfDeparture",
		header: "Date and Time of Departure(UTC)",
		accessorFn: (row) => {
			if (row.dateTimeOfDeparture) {
				return convertLocaltoUTCFormat(row.dateTimeOfDeparture);
			}
		},
	},
	{
		accessorKey: "portalVerificationStatus",
		header: "Portal Initial Verification Status",
	},
	{
		accessorKey: "co2mrv",
		header: "CO2 MRV",
	},
	{
		accessorKey: "ch4mrv",
		header: "CH4 MRV",
	},
	{
		accessorKey: "n2omrv",
		header: "N2O MRV",
	},
	{
		accessorKey: "reductionFactor",
		header: "Reduction Factor",
	},
	{
		accessorKey: "carbonCaptureAndStorage",
		header: "Carbon Capture & Storage",
	},
	{
		accessorKey: "ghgMrv",
		header: "GHG MRV",
	},
];
